import styled from "styled-components";
import { buttonBaseStyles, onClickWithAnalytics } from "./common";
import { ButtonCommonProps } from "./types";
import { Colors } from "@/theme";
import { KeyColors } from "@/theme/colors";

/**
 * Styled Components
 */

export const StyledButtonRegular = styled.button<{
  $color: KeyColors;
  $textColor: KeyColors;
  $type: "button" | "submit" | "restart";
  $thickBorder?: string;
}>`
  ${buttonBaseStyles};
  ${({ theme, $color, $type, $textColor, $thickBorder }) => `
    display: flex;
    justify-content: ${$type === "restart" ? "space-between" : "center"};
    gap: 8px;
    background-color: ${$color ? theme.Colors[$color] : theme.Colors.black};
    color: ${$textColor ? theme.Colors[$textColor] : theme.Colors.white};
    border: none;
    border-radius: ${$type === "restart" ? "8px" : "24px"};
    padding: ${$type === "restart" ? "12px" : "10px 0px 10px"};
    border: 1px solid ${$type === "restart" ? Colors.gray200 : "transparent"};
    ${$type === "restart" && `max-width: 100%;`}
    ${
      $thickBorder &&
      `border: 1px solid ${$thickBorder}; border-bottom: 3px solid ${$thickBorder};`
    }
    &:hover {
      opacity: 0.9;
    }

    :disabled {
      background-color: ${theme.Colors.gray200};
      color: ${theme.Colors.gray300};
    }
  `}
`;

/**
 * ButtonRegular Component
 */

export const ButtonRegular = ({
  disabled = false,
  onClick,
  testId,
  text,
  color = "black",
  type = "button",
  icon,
  textColor = "white",
  thickBorder,
  analyticsContext,
  ...rest
}: ButtonCommonProps) => (
  <StyledButtonRegular
    disabled={disabled}
    data-testid={testId}
    onClick={() =>
      onClickWithAnalytics(onClick, {
        button_text: text,
        button_type: type,
        ...analyticsContext ?? {},
      })
    }
    $type={type}
    $color={color}
    $textColor={textColor}
    $thickBorder={thickBorder}
    {...rest}
  >
    {text}
    {icon}
  </StyledButtonRegular>
);
